/**
 * One debug-log line — shared by the on-screen panel (this tab's ring) and
 * the admin page's report cards (someone else's ring), so both read the same.
 */
import type { DebugLogEntryDto } from "@kola/shared";
import { useState } from "react";

import { formatDebugTime } from "../../core/debug-log.js";

export interface DebugEntryLineProps {
  entry: DebugLogEntryDto & { count?: number };
}

export function DebugEntryLine({ entry }: DebugEntryLineProps) {
  const [expanded, setExpanded] = useState(false);
  const repeat = entry.count ?? 1;
  return (
    <li className={`debug-log-entry level-${entry.level}`}>
      <span className="debug-log-time">{formatDebugTime(entry.ts)}</span>
      <span className="debug-log-level">{entry.level}</span>
      <span className="debug-log-source">{entry.source}</span>
      <span className="debug-log-message">
        {entry.message}
        {repeat > 1 && <span className="debug-log-repeat">×{repeat}</span>}
      </span>
      {entry.detail !== undefined ? (
        <button
          type="button"
          className="debug-log-more"
          onClick={() => setExpanded((value) => !value)}
          aria-expanded={expanded}
        >
          {expanded ? "Hide" : "Details"}
        </button>
      ) : (
        <span />
      )}
      {expanded && entry.detail !== undefined && (
        <pre className="debug-log-detail">{entry.detail}</pre>
      )}
    </li>
  );
}
